<template>
  <OperativeTableBodyRow class="operative-table-body-kpi-row" :class="{ 'only-semaphore': hideLabel }" :values="values" :strong="strong" :align="align">
    <template #default><slot></slot></template>
    <template #cell-container="{ value, strong, i }">
      <KpiValue class="operative-table-value-column operative-table-kpi-value-column" :key="'row-cell-' + i" :strong="strong" :rank="value.rank" :value="value.value" :scale="scale" :hide-label="hideLabel" :align="align" :showValue="showValues" />
    </template>
  </OperativeTableBodyRow>
</template>

<script>

import KpiValue from './KpiValue.vue';
import OperativeTableBodyRow from '../OperativeTableBodyRow.vue';

export default {
  components: {
    OperativeTableBodyRow,
    KpiValue,
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    strong: {
      type: Boolean,
      default: false,
    },
    scale: {
      type: Object,
      default: null,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: 'default',
    },
    showValues: {
      type: Boolean,
      default: false,
    },
  },
};

</script>

<style lang="scss">

.operative-table-body-row {
  .operative-table-kpi-value-column.operative-table-value-column {
    text-align: left;
    white-space: nowrap;
  }

  &.only-semaphore {
    .operative-table-kpi-value-column.operative-table-value-column {
      min-width: 50px;
    }
  }
}

</style>
